import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PagePatentReportData } from '../api/page-patent-report-data';
import { PatentReportRequest, PatentVolumeReportRequest } from '../api/patent-report-request';
import { GeneralSearch } from '../api/general-search';
import { SearchItem } from '../api/search-item';
import { Alias } from '../api/alias';

@Injectable()
export class PatentService {

  constructor(private httpClient: HttpClient) {
  }

  public searchPatent(request: PatentReportRequest): Observable<PagePatentReportData> {
    const url = '/patent/open/report/search';

    // Not yet sure if this is a post or get
    return this.httpClient.post<PagePatentReportData>(url, request);
  }

  public searchCity(generalSearch: GeneralSearch): Observable<SearchItem[]> {
    const url = '/patent/open/report/search/city';

    // Not yet sure if this is a post or get
    return this.httpClient.post<SearchItem[]>(url, generalSearch);
  }

  public searchApplicantVolumeReport(request: PatentVolumeReportRequest): Observable<PagePatentReportData> {
    const url = '/patent/open/report/search/applicant/volume';

    // Not yet sure if this is a post or get
    return this.httpClient.post<PagePatentReportData>(url, request);
  }

  public searchAgentVolumeReport(request: PatentVolumeReportRequest): Observable<PagePatentReportData> {
    const url = '/patent/open/report/search/agent/volume';

    // Not yet sure if this is a post or get
    return this.httpClient.post<PagePatentReportData>(url, request);
  }

  public searchUsptoVolumeReport(request: PatentVolumeReportRequest): Observable<PagePatentReportData> {
    const url = '/patent/open/report/search/uspto/volume';

    // Not yet sure if this is a post or get
    return this.httpClient.post<PagePatentReportData>(url, request);
  }

  public getAliases(): Observable<Alias[]> {
    const url = '/patent/open/report/search/aliases';
    return this.httpClient.get<Alias[]>(url);
  }

  public getAlias(aliasId: number): Observable<Alias> {
    const url = `/patent/open/report/search/alias/${aliasId}`;
    return this.httpClient.get<Alias>(url);
  }

  public deleteAlias(aliasId: number): Observable<any> {
    const url = `/patent/open/report/search/alias/${aliasId}`;
    return this.httpClient.delete<any>(url);
  }

  public searchParticipantForAlias(theAliasId: number,
                                   theSearch: string,
                                   type: string,
                                   excludeParticipantList: number[]): Observable<SearchItem[]> {
    const request = {
      aliasId: theAliasId,
      search: theSearch,
      participantType: type,
      excludeParticipantIds: excludeParticipantList
    };

    const url = `/patent/open/report/search/alias/participant`;
    return this.httpClient.post<SearchItem[]>(url, request);
  }

  public updateAlias(alias: Alias): Observable<Alias> {
    const url = `/patent/open/report/search/alias`;
    return this.httpClient.post<Alias>(url, alias);
  }


  public searchUsptoFirm(generalSearch: GeneralSearch): Observable<SearchItem[]> {
    const url = '/patent/open/report/search/uspto/firm';

    // Not yet sure if this is a post or get
    return this.httpClient.post<SearchItem[]>(url, generalSearch);
  }

}
